// @flow

import * as React from 'react'
import styled, { css } from 'styled-components'
import { classnames } from '@/helpers'
import styles from './styles.scss'

type PaperProps = {|
  children: React.Node,
  isColumn?: boolean,
  style?: ?Object,
  className?: string,
  onClick?: () => void,
|}

const StyledPaper = styled.div`
  flex-direction: row;
  ${props =>
    props.isColumn &&
    css`
      flex-direction: column;
    `}
`

const Paper = (props: PaperProps) => {
  const { children, isColumn, style, className, onClick } = props
  return (
    <StyledPaper className={classnames(styles.paper, className)} isColumn={isColumn} style={style} onClick={onClick}>
      {children}
    </StyledPaper>
  )
}

Paper.defaultProps = {
  isColumn: false,
  style: {},
  className: '',
  onClick: () => {},
}

export default Paper
